import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const AddDocumentBlue = (props) => (<Svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <Rect width="32" height="32" rx="8" fill="#E7F3FB"/>
    <Path d="M16.0005 9.77783V22.222" stroke="#3999DE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M9.77832 16H22.2225" stroke="#3999DE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default AddDocumentBlue;
